import { useApp } from "../context/AppContext";

/**
 * Breadcrumb
 *
 * Props:
 *   crumbs – array of { label: string, page?: string, cat?: string }
 *            The last crumb is always rendered as plain text (current page).
 */
export default function Breadcrumb({ crumbs }) {
  const { navigate } = useApp();

  return (
    <div className="breadcrumb">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <span key={crumb.label} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {index > 0 && <span>›</span>}
            {isLast || !crumb.page ? (
              <span>{crumb.label}</span>
            ) : (
              <button onClick={() => navigate(crumb.page, crumb.cat || "all")}>
                {crumb.label}
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
}
